import { FC, useEffect, useState } from 'react'
import { useTranslation } from "react-i18next";
import css from './index.module.less';
import { Button, Form, Image, Input, Toast } from 'antd-mobile'
import userIcon from '@img/user.png';
import smsIcon from '@img/sms.png';
import dyIcon from '@img/dy.png';
import wxIcon from '@img/wechat.png'
import zfbIcon from '@img/zfb.png'
import { EyeInvisibleOutline, EyeOutline } from 'antd-mobile-icons'
import { typeList, rules } from '@/pages/user/Login/const'
import { getTokenApi, login } from '@/api/user'
import { actionTypes, useStoreDispatch, useStoreState } from '@/store'
import { useNav } from '@/hooks/useNav'
import { useSelectRole } from '@/hooks/useSelectRole'
import { getUrlParam, objToUrlParams } from '@/utils'
import { PhoneFormItems } from '@/components/PhoneFormItems'
import { AgreeFormItem } from '@/components/AgreeFormItem'
import { SMS_TYPE } from '@/components/SmsCodeFormItem/const'
import { SelectAccountPopup } from '@/pages/user/Login/components/SelectAccountPopup'
import { encrypt, genEncryptKey } from '@/utils/crypto'


export const Login: FC = props => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const type = Form.useWatch('type', form);
  const { nav } = useNav();
  const [getRoles] = useSelectRole();
  const dispatch = useStoreDispatch();
  const { user, inner }: any = useStoreState();
  const [submitting, setSubmitting] = useState(false)
  const [popupVisible, setPopupVisible] = useState(false)
  const [users, setUsers] = useState([])

  // 如果登录成功或者进入登录页时已登录 则跳转到选择角色页
  useEffect(() => {
    user.isLogin && getRoles();
  }, [user.isLogin])

  useEffect(() => {
    form.setFieldsValue({
      // sdk: sdkList[0].value,
      type: inner.isFrom ? inner.type : typeList[1].value,
      account: '',
      password: '',
      // phone: '',
      code: '',
      agree: false,
      ts: Date.now(),
    })
  }, []);

  // 判断是否是账号登录
  const isAccountLogin = type => type === typeList[0].value;
  const isPhoneLogin = type => type === typeList[1].value;
  const isInnerLogin = type => type === typeList[2].value;

  // 更新：点击提交 后端会返回一个临时token和账号列表 如果只有一项则直接静默调用生成token接口 如果有两项则需要弹窗让用户选择登录哪个账号
  const onFinish = async (values) => {
    const model = { ...values, ts: Date.now() }
    if (isAccountLogin(values.type)) model.password = encrypt(model.password, genEncryptKey(model.ts))

    setSubmitting(true)
    const res = await login(model).finally(() => setSubmitting(false))
    if (res?.code === 0) {
      res.data.userVos.map(option => {
        option.account = model.account
        option.token = res.data.token
      })
      if (res.data.userVos?.length > 1) {
        setUsers(res.data.userVos)
        setPopupVisible(true)
      } else {
        getToken(res.data.userVos[0])
      }
    }
  }

  // 在选择账号弹框中点击确定的回调
  const onSelect = async option => {
    const res = await getToken(option)
    if (res?.code === 0) setPopupVisible(false)
  }

  const getToken = async model => {
    setSubmitting(true)
    const res = await getTokenApi(model).finally(() => setSubmitting(false))
    if (res?.code === 0) {
      Toast.show({ icon: 'success', content: `${t('user-center.login.login-tips')}` });
      localStorage.setItem('token', res.data.token);
      dispatch({ type: actionTypes.SET_USER, payload: { isLogin: true } });
    }
    return res
  }

  // 跳转其他登录
  const onOtherLogin = (type: number) => {
    if (!form.getFieldsValue()?.agree) {
      return Toast.show({ icon: 'fail', content: `请先勾选用户协议` });
    }
    nav(`/select-game/${type}`)
  }

  // 海外用户不应该访问登录页面，重定向到首页让 Layout 显示登录弹框
  if (process.env.REACT_APP_IDN_ENV === 'hw') {
    //  window.location.href = '/show-status'
    window.location.href = '/'
    return
  }

  return (
    <>
      <div className={css.Page}>
        <Form form={form} className={css.Form} onFinish={onFinish}>
          <div className={css.PageHd}>
            {/*<Form.Item name='sdk' rules={rules.sdk}>*/}
            {/*  <RadioGroup options={sdkList} />*/}
            {/*</Form.Item>*/}
            {isAccountLogin(type) && <AccountFormItems />}
            {isPhoneLogin(type) && <PhoneFormItems form={form} model={{ type: SMS_TYPE.LOGIN }} phoneName={'account'} />}
            {isInnerLogin(type) && <InnerFormItems />}
            <AgreeFormItem name={'agree'} />
          </div>

          <div className={css.BtnSubmitWrap}>
            <Button className={css.BtnSubmit} block type='submit' color='primary' size='large' loading={submitting}>{t('user-center.login.login-btn')}</Button>
          </div>

          <Form.Item name='type'>
            <div className={css.PageBd}>
              <div className={css.BdHd}>{t('user-center.login.login-other')}</div>
              <div className={css.BdBd}>
                {isAccountLogin(type)
                  ? <div className={css.iconBox}>
                      <Image className={css.IconImg} src={smsIcon} onClick={() => form.setFieldValue('type', typeList[1].value)} />
                      <span>手机登录</span>
                  </div>
                  : <div className={css.iconBox}>
                      <Image className={css.IconImg} src={userIcon} onClick={() => form.setFieldValue('type', typeList[0].value)} />
                      <span>账号密码</span>
                    </div>
                }
                <div className={css.iconBox}>
                  <Image className={css.IconImg} src={dyIcon} onClick={() => { onOtherLogin(2) }} />
                  <span>抖音游戏</span>
                </div>
                <div className={css.iconBox}>
                  <Image className={css.IconImg} src={wxIcon} onClick={() => { onOtherLogin(1) }} />
                  <span>微信游戏</span>
                </div>
                <div className={css.iconBox}>
                  <Image className={css.IconImg} src={zfbIcon} onClick={() => { onOtherLogin(3) }} />
                  <span>支付宝游戏</span>
                </div>
              </div>
            </div>
          </Form.Item>
        </Form>
      </div>
      <SelectAccountPopup visible={popupVisible} list={users} onSelect={onSelect} />
    </>
  )
}



// 账号登录表单项
const AccountFormItems: FC = props => {
  const [pwdVisible, setPwdVisible] = useState(false);
  const { t } = useTranslation();
  return (
    <>
      <Form.Item className={css.InputWrap} name='account' rules={rules.account}>
        <Input className={css.Input} placeholder={t('user-center.login.account-placeholder')} clearable />
      </Form.Item>
      <Form.Item className={css.InputWrap} name='password' rules={rules.password} extra={
        pwdVisible ? (<EyeOutline onClick={() => setPwdVisible(false)} />) : (<EyeInvisibleOutline onClick={() => setPwdVisible(true)} />)
      }>
        <Input className={css.Input} placeholder={t('user-center.login.pwd-placeholder')} clearable type={pwdVisible ? 'text' : 'password'} />
      </Form.Item>
    </>
  )
}


// 内部登录表单项
const InnerFormItems: FC = props => {
  const { t } = useTranslation();
  return (
    <>
      <Form.Item className={css.InputWrap} name='account' rules={rules.account}>
        <Input className={css.Input} placeholder={t('user-center.login.openId-placeholder')} clearable />
      </Form.Item>
      <Form.Item className={css.InputWrap} name='userId' rules={rules.userId}>
        <Input className={css.Input} placeholder={t('user-center.login.userId-placeholder')} clearable />
      </Form.Item>
    </>
  )
}
